import { hasFlag } from 'legacy/lut/components/widgets/public/partner360/reports/managerDashboard/helpers/hasFlag'

import { IWelcomeFlowPartner, WelcomeFlowBitClasses } from '../../../api/types'
import {
  MpsIcon,
  PersonalSystemServicesIcon,
  Poly,
  PrintServicesIcon,
  TopIconMini,
} from '../../icons'

import styles from './PartnerIcons.module.scss'

interface PartnerIconsProps {
  partner: IWelcomeFlowPartner
}

const POLY_SPECIALIZATION_FLAG = 32

export const PartnerIcons = ({ partner }: PartnerIconsProps) => {
  const hasTopBps =
    hasFlag(WelcomeFlowBitClasses.TopMarketBps, partner.BitClass) ||
    hasFlag(WelcomeFlowBitClasses.TopWwBps, partner.BitClass)

  const hasTopOph =
    hasFlag(WelcomeFlowBitClasses.TopMarketOph, partner.BitClass) ||
    hasFlag(WelcomeFlowBitClasses.TopWwOph, partner.BitClass)

  const hasTopDistributor = hasFlag(WelcomeFlowBitClasses.TopDistributor, partner.BitClass)
  const hasTopRetailer = hasFlag(WelcomeFlowBitClasses.TopRetailer, partner.BitClass)
  const hasPoly = hasFlag(POLY_SPECIALIZATION_FLAG, partner.BitSpecialization)
  const hasStrategicPsServices = hasFlag(
    WelcomeFlowBitClasses.StrategicPsServices,
    partner.BitClass
  )
  const hasStrategicPrintServices = hasFlag(
    WelcomeFlowBitClasses.StrategicPrintServices,
    partner.BitClass
  )
  const hasStrategicMps = hasFlag(WelcomeFlowBitClasses.StrategicMps, partner.BitClass)

  const showTop = hasTopBps || hasTopOph || hasTopDistributor || hasTopRetailer

  return (
    <div className={styles.root}>
      {showTop && <TopIconMini />}
      {hasPoly && <Poly />}
      {hasStrategicPsServices && <PersonalSystemServicesIcon />}
      {hasStrategicPrintServices && <PrintServicesIcon width={16} height={18} />}
      {hasStrategicMps && <MpsIcon />}
    </div>
  )
}
